import { useTranslation } from "react-i18next"

interface IMedicineInfoItem {
    label: string
    value: string | number
    variant?: "in-stock" | "out-of-stock" | "default"
}

const MedicineInfoItem = ({ label, value, variant = "default" }: IMedicineInfoItem) => {
    const { t } = useTranslation()

    return (
        <div className="medicine-info-item">
            <span className="medicine-label">{t(label)}</span>
            <span className={`medicine-value ${variant !== "default" ? variant : ""}`}>
                {value}
            </span>
        </div>
    )
}

export default MedicineInfoItem

